<div
    class="cell-header-wrapper"
    fxLayout="row"
    fxLayoutAlign="center flex-end"
    (click)="select.open()"
>
    <div class="upper table-header-text cell-header-placeholder text-primary">
        {{ placeholder }}
    </div>
    <div *ngIf="!!this.selectedFilters.length" class="filter-circle"></div>

    <mat-select
        #select
        [placeholder]="placeholder"
        disableOptionCentering="true"
        multiple
        [formControl]="selected"
        class="upper mat-caption"
        panelClass="panel-class"
        (openedChange)="selectOpenToggle($event)"
    >
        <mat-select-trigger>
            <p>{{ placeholder }}</p>
        </mat-select-trigger>

        <mat-optgroup label="Sortowanie">
            <mat-option
                #matOptionNormal
                value="normal"
                (click)="selectSorting(false)"
                >&uarr;</mat-option
            >
            <mat-option
                #matOptionReverse
                value="reverse"
                (click)="selectSorting(true)"
                >&darr;</mat-option
            >
        </mat-optgroup>

        <div class="filter-search-wrapper" *ngIf="filterDef">
            <label class="mat-optgroup-label">Wybierz filtr</label>
            <div
                class="filter-search ph-xxs pv-xxs"
                *ngIf="filterDef"
                fxLayout="row"
                fxLayoutAlign="flex-start"
            >
                <mat-icon class="text-primary">search</mat-icon>
                <div class="filter-search-input">
                    <input
                        #selectFilterSearch
                        type="text"
                        (keydown)="$event.stopPropagation()"
                        (keyup)="$event.stopPropagation()"
                        placeholder="Wyszukaj"
                    />
                </div>
            </div>
        </div>

        <mat-optgroup class="select-filters" *ngIf="filterDef">
            <mat-option
                *ngFor="let elem of filterList$ | async"
                [value]="elem"
                (click)="selectFilter(elem)"
                color="primary"
            >
                <p>{{ elem }}</p>
            </mat-option>
        </mat-optgroup>
        <div class="too-many-results" *ngIf="filterDef && bigResult">Za dużo elementów na liście, użyj wyszukiwania!</div>

        <div class="select-buttons">
            <div fxLayout="row" fxLayoutGap="2%" class="ph-xxs pv-xxxs">
                <button
                    class="select-button-deny"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    (click)="clearSelFilter()"
                >
                    <mat-icon class="text-red">close</mat-icon>
                    <p class="semi-bold-font text-grey">Wyczyść</p>
                </button>
                <button
                    class="select-button-approve"
                    (click)="emitSelFilterOnClick()"
                >
                    <mat-icon class="text-green">check</mat-icon>
                </button>
            </div>
        </div>
    </mat-select>
    <mat-icon>arrow_drop_down</mat-icon>
</div>
